import React, { useState } from 'react';
import RAGDocumentManagement from './RAGDocumentManagement';
import '../assets/AllTabsCommon.css';
import '../assets/FleetAnalytics.css';

const AI_TABS = [
    { key: 'rag', label: '📄 RAG Document Management' },
];

function AITab({ userInfo, role }) {
    const [activeTab, setActiveTab] = useState('rag');

    return (
        <div className="analytics-shell">
            <div className="analytics-tabs">
                {AI_TABS.map((t) => (
                    <div
                        key={t.key}
                        className={`analytics-tab${activeTab === t.key ? ' active' : ''}`}
                        onClick={() => setActiveTab(t.key)}
                    >
                        {t.label}
                    </div>
                ))}
            </div>

            {activeTab === 'rag' && (
                <RAGDocumentManagement userInfo={userInfo} role={role} />
            )}
        </div>
    );
}

export default AITab;
